import ApiService from "vamos/cockpit/base/services/type/ApiService";
import { ResponseSupplierServerConfigurationDto, SupplierServerConfigurationDto } from "vamos/cockpit/model/api/vamos.private.api.types";
import BaseController from "vamos/cockpit/base/controller/type/BaseController";

export  interface ServerConfigurationDto {
    bmecat: SupplierServerConfigurationDto;
    opentrans: SupplierServerConfigurationDto;
}

export default class ServerConfigurationHandler {
    controller:BaseController;
    constructor(controller?:BaseController) {
        this.controller = controller;
    }


    async loadServerConfiguration(guid:string):Promise<ServerConfigurationDto> {
        const defaultOpenTransResponse: ResponseSupplierServerConfigurationDto = await ApiService.getInstance().getRestJsonData(`/supplier-server/default/opentrans/${guid}`);
        const defaultBmecatResponse:ResponseSupplierServerConfigurationDto = await ApiService.getInstance().getRestJsonData(`/supplier-server/default/bmecat/${guid}`);
        return {
            bmecat: defaultBmecatResponse.content ?? {},
            opentrans: defaultOpenTransResponse.content ?? {}
        }
    }
    async updateServerConfigurations(guid:string, bmecatConfig:SupplierServerConfigurationDto, opentransConfig:SupplierServerConfigurationDto):Promise<void> {
        await ApiService.getInstance().putRestJsonData(`/supplier-server/default/opentrans/${guid}` ,opentransConfig);
        await ApiService.getInstance().putRestJsonData(`/supplier-server/default/bmecat/${guid}` , bmecatConfig);

    }



}